import { combineReducers } from '@reduxjs/toolkit'
import financeAccount from './financeAccountSlice'
import group from './groupSlice';
import account from './accountSlice'
import category from './categorySlice'
import transaction from './transactionSlice'
import balancePerAccount from './balancePerAccountSlice'
import balancePerCategory from './balancePerCategorySlice'
import myDashboard from './myDashboardSlice'
import futureBalance from './futureBalanceSlice'
import navigation from './navigationSlice'
import appMain from './appMainSlice'

const appReducer = combineReducers({
    financeAccount,
    group,
    navigation,
    account,
    category,
    transaction,
    balancePerAccount,
    balancePerCategory,
    myDashboard,
    futureBalance,
    appMain
})

const rootReducer = (state, action) => {
    // Clear all data when user logs out
    if (action.type === 'account/logoff' || action.type === 'account/logoffUser') {
        state = undefined;
    }
    return appReducer(state, action);
}

export default rootReducer
